<div [ngClass]="{'container': true, 'loaded': !loading}" #container>
    <div class="canvas-container">
        <canvas #stats class="canvas" width="800" height="800"></canvas>
    </div>

</div>
